import transportModesReducer from './TransportModesReducer';

const initialState = {};

export default function rootReducer(state = initialState, action) {
  return transportModesReducer(state, action);
}

